const API_BASE = "/api";

export interface SpinResult {
  reels: number[];
  bet: number;
  payout: number;
  mult: number;
  wallet: number;
}

/** Thin client for the server-decided slot machine. */
export class Slots {
  async spin(
    name: string,
    token: string,
    bet: number,
  ): Promise<SpinResult | { error: string }> {
    try {
      const res = await fetch(`${API_BASE}/slots/spin`, {
        method: "POST",
        headers: { "content-type": "application/json", authorization: `Bearer ${token}` },
        body: JSON.stringify({ name, bet }),
      });
      const data = (await res.json().catch(() => ({}))) as Partial<SpinResult> & {
        ok?: boolean;
        error?: string;
      };
      if (!res.ok || !data.ok || !Array.isArray(data.reels)) {
        return { error: data.error ?? "error" };
      }
      return {
        reels: data.reels,
        bet: Number(data.bet) || bet,
        payout: Math.max(0, Number(data.payout) || 0),
        mult: Number(data.mult) || 0,
        wallet: Math.max(0, Number(data.wallet) || 0),
      };
    } catch {
      return { error: "network" };
    }
  }
}
